import api from "./api";

const MaterialReconciliationReportService = {

    getReport: async (params) => {

        const response = await api.get(
            "/materialReconciliationReport/getReport",
            {
                params: {
                    companyId: params.companyId || undefined,
                    employeeId: params.employeeId || undefined,
                    roleId: params.roleId || undefined,
                    projectCategoryId: params.projectCategoryId || undefined,
                    projectId: params.projectId || undefined,
                    storeId: params.storeId || undefined,
                    locationId: params.locationId || undefined,
                    startDate: params.startDate || undefined,
                    endDate: params.endDate || undefined,
                    page: params.page || 1,
                    limit: params.limit || 10,
                },
            }
        );

        return response.data;
    },

};

export default MaterialReconciliationReportService;